import { useEffect } from 'react';
import { lockBodyScroll } from '@/utils/body-scroll-lock';

/**
 * Locks body scroll while `active` is true and unlocks on cleanup.
 * Lock and unlock are always paired symmetrically — including on unmount
 * mid-animation — via the reference-counted utility in body-scroll-lock.ts.
 *
 * @param active Whether the lock should be engaged. Defaults to `true`, so
 *   components that are only rendered when a modal is open can simply write
 *   `useBodyScrollLock()` with no arguments.
 */
export function useBodyScrollLock(active = true): void {
  useEffect(() => {
    if (!active) return;
    const unlock = lockBodyScroll();
    return unlock;
  }, [active]);
}
